import { CommonModule } from '@angular/common';
import { Component, computed, effect, inject, input, output, viewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonGroupComponent } from '../button-group/button-group.component';
import { LoginFormComponent } from '../login-form/login-form.component';
import { RegisterFormComponent } from '../register-form/register-form.component';
import { ForgotPasswordFormComponent } from '../forgot-password-form/forgot-password-form.component';
import { GuestCheckoutFormComponent } from '../../checkout/guest-checkout-form/guest-checkout-form.component';
import { AuditService } from '../../core/services/audit.service';
import { OrderService } from '../../core/services/order.service';

@Component({
  selector: 'cwo-signing-forms',
  standalone: true,
  imports: [CommonModule, FormsModule, ButtonGroupComponent, LoginFormComponent, RegisterFormComponent, ForgotPasswordFormComponent, GuestCheckoutFormComponent],
  templateUrl: './signing-forms.component.html',
  styleUrl: './signing-forms.component.scss'
})
export class SigningFormsComponent {
  private auditService = inject(AuditService);
  private orderService = inject(OrderService);
  activePage = 'Sign In';
  boxShadow = input<string>('');
  submitButton = input<string | undefined>();
  formPadding = input<string>('');
  hideGuestButton = input(false);
  activePageInput = input<string>();
  hasNewCreditCard = input<boolean>(false);
  parentExpanded = input<boolean>(true);
  showTableNumberInput = input(false);
  showTableNumberText = input(false);
  tableNumber = input('');
  showTableNumberError = input(false);
  isSelfOrder = computed(() => this.orderService.order().isInitialized && this.orderService.order().isSelfOrderSource);

  readonly loginFormCompRef = viewChild<LoginFormComponent>('loginFormComp');
  readonly registerFormCompRef = viewChild<RegisterFormComponent>('registerFormComp');
  readonly guestFormCompRef = viewChild<GuestCheckoutFormComponent>('guestFormComp');


  readonly activePageChange = output<string>();
  readonly personalDetailsCompleted = output<string>();
  readonly tableNumberChange = output<string>();
  readonly tableNumberBlur = output();

  constructor() {
    effect(() => {
      if(this.activePageInput()){
        this.activePage = this.activePageInput() ?? 'Sign In';
      }
    });
  }
  onActivePageChange (value: string) {
    this.activePageChange.emit(value);
    this.auditService.createAudit(() => `${this.activePage} option chosen`);
  }

  forgotPasswordClicked(page:string) {
    this.activePage = page;
    this.activePageChange.emit(page);
  }

  guestCheckoutClicked(page:string) {
    this.activePage = page;
    this.activePageChange.emit(page);
  }

  backToSignIn(){
    this.activePage = 'Sign In';
    this.activePageChange.emit('Sign In');
  }
}
